import React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { Can } from '../Can';
import { TimesheetStatus } from '../timesheet/Timesheet';

export default class TimesheetExportButton extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
        };
    }

    toggleModal = () => {
        const { showModal } = this.state;

        if (this.isExportButtonDisabled()) {
            this.setState({ showModal: false });
            return;
        }

        this.setState({ showModal: !showModal });
    };

    isExportButtonDisabled = () => {
        const { gridOptions, isExporting } = this.props;

        if (isExporting) {
            return true;
        }

        if (
            !gridOptions ||
            !gridOptions.api ||
            !gridOptions.api.getFilterModel
        ) {
            return true;
        }

        const filterModel = gridOptions.api.getFilterModel();

        const timesheetStatusId = filterModel.timesheetStatusId?.value;

        return timesheetStatusId != TimesheetStatus.Approved;
    };

    localExportClick = async () => {
        const { onExportClick } = this.props;

        await onExportClick();

        this.setState({ showModal: false });
    };

    render() {
        const { isExporting, timesheetExportEnabled } = this.props;

        const { showModal } = this.state;

        if (!timesheetExportEnabled) {
            return null;
        }

        const exportButtonDisabled = this.isExportButtonDisabled();

        return (
            <>
                <Can I="export" a="timesheet">
                    <span
                        style={{
                            float: 'right',
                            position: 'relative',
                            top: '-5px',
                        }}
                    >
                        <Button
                            size="sm"
                            style={{ marginRight: '10px' }}
                            color="danger"
                            onClick={this.toggleModal}
                            disabled={exportButtonDisabled}
                        >
                            {isExporting && (
                                <FontAwesomeIcon
                                    icon={faCircleNotch}
                                    className="fa-spin mr-2"
                                    size="sm"
                                />
                            )}
                            Export
                        </Button>
                    </span>
                </Can>

                <Modal isOpen={showModal} toggle={this.toggleModal}>
                    <ModalHeader toggle={this.toggleModal}>
                        Export Timesheets and Time Off Requests
                    </ModalHeader>
                    <ModalBody>
                        <div>
                            When exporting, only the date filter range will be
                            honored.
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.localExportClick}>
                            Ok
                        </Button>
                        <Button
                            color="secondary"
                            className="ml-1"
                            onClick={this.toggleModal}
                        >
                            Cancel
                        </Button>
                    </ModalFooter>
                </Modal>
            </>
        );
    }
}
